import './announcements.css';
import eLinkLogo from '@assets/elink_distribution_ag_logo.svg';

interface Props {
  title: string;
  message: string;
}

/** Full-screen block shown to external users while maintenance mode is on. */
export function MaintenancePage({ title, message }: Props) {
  return (
    <div className="eos-maintenance">
      <div className="eos-maintenance__card">
        <img
          className="eos-maintenance__logo"
          src={eLinkLogo}
          alt="eLink Distribution AG"
        />
        <div className="eos-maintenance__icon" aria-hidden>
          🛠️
        </div>
        <div className="eos-maintenance__title">{title}</div>
        <div className="eos-maintenance__message">{message}</div>
      </div>
    </div>
  );
}
